import { type ReactNode, useState } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { cn } from '@/utils/cn';
import type { TeamMember } from '../types';
import { EditPhraseModal } from './edit-phrase-modal';
import { TeamCardPhoto } from './team-member-parts';

const PRE_STATUSES = new Set(['test', 'verifying']);

type Props = {
  member: TeamMember;
  onSelect?: (id: string) => void;
};

function PhraseEditor(p: {
  member: TeamMember;
  onClose: () => void;
}): ReactNode {
  return (
    <EditPhraseModal
      open
      onClose={p.onClose}
      current={p.member.personal_phrase}
    />
  );
}

export function TeamMemberCard({ member, onSelect }: Props): ReactNode {
  const [editing, setEditing] = useState(false);
  const isSelf = useAuth().user?.id === member.id;
  const dimmed = PRE_STATUSES.has(member.account_status ?? '');
  const handleClick = onSelect ? (): void => onSelect(member.id) : undefined;
  return (
    <div
      className={cn(dimmed && 'opacity-60', handleClick && 'cursor-pointer')}
      onClick={handleClick}
      role={handleClick ? 'button' : undefined}
      tabIndex={handleClick ? 0 : undefined}
    >
      <TeamCardPhoto
        member={member}
        isSelf={isSelf}
        onEdit={() => setEditing(true)}
      />
      {editing && (
        <PhraseEditor member={member} onClose={() => setEditing(false)} />
      )}
    </div>
  );
}
